import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("en-GB") : "—");
const when = (n) => (n < 0 ? `${Math.abs(n)}d overdue` : n === 0 ? "due today" : `in ${n}d`);

export default function Calendar() {
  const [d, setD] = useState(null);
  const [days, setDays] = useState(60);
  const [err, setErr] = useState("");

  const load = (w) => api.get("/calendar/upcoming", { params: { days: w } }).then((r) => setD(r.data?.data)).catch((e) => setErr(e?.response?.data?.message || "Failed to load"));
  useEffect(() => { load(days); }, [days]);

  const items = d?.items || [];
  return (
    <div>
      <h1>Compliance Calendar</h1>
      <p className="sub">Upcoming & overdue compliance deadlines — calendar tasks plus due dates pulled from vendors, retention and repositories.</p>
      {err && <div className="err">{err}</div>}

      <div className="kpis">
        <div className="kpi danger"><div className="n">{d?.overdue ?? 0}</div><div className="l">Overdue</div></div>
        <div className="kpi warn"><div className="n">{d?.dueSoon ?? 0}</div><div className="l">Due within {days}d</div></div>
      </div>

      <div className="card">
        <div className="toolbar">
          <select style={{ maxWidth: 180 }} value={days} onChange={(e) => setDays(Number(e.target.value))}>
            <option value={30}>Next 30 days</option><option value={60}>Next 60 days</option><option value={90}>Next 90 days</option><option value={180}>Next 180 days</option>
          </select>
          <div style={{ flex: 1 }} />
          <button className="btn sm" onClick={async () => {
            try { const r = await api.post("/notifications/run/calendar-digest"); alert(r.data?.message || "Digest generated"); }
            catch (e) { alert(e?.response?.data?.message || "Failed"); }
          }}>Email digest now</button>
          <Link className="btn sm" to="/m/calendar">Manage tasks</Link>
        </div>
        <div className="tablewrap">
          <table>
            <thead><tr><th>Due</th><th>When</th><th>Task</th><th>Category</th><th>Source</th><th>Owner</th></tr></thead>
            <tbody>
              {items.map((i, idx) => (
                <tr key={idx} style={i.overdue ? { background: "#fef2f2" } : null}>
                  <td>{fmt(i.due_date)}</td>
                  <td><span className={`pill ${i.overdue ? "danger" : i.daysLeft <= 7 ? "warn" : ""}`}>{when(i.daysLeft)}</span></td>
                  <td>{i.title}</td>
                  <td>{i.category || "—"}</td>
                  <td><span className="pill">{i.source}</span></td>
                  <td>{i.owner || "—"}</td>
                </tr>
              ))}
              {!items.length && <tr><td colSpan={6}><div className="empty">Nothing due in this window.</div></td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
